import type {
  AllowedCountryCode,
  AllowedCurrencyCode,
} from '@nrdy-marketing-engine/cart/@types/cart-state';

export const CURRENCY_CODE_MAP = { US: 'USD', CA: 'CAD', GB: 'GBP' } as Record<
  AllowedCountryCode,
  AllowedCurrencyCode
>;
